import { Box, Text, Flex } from "@chakra-ui/react"
import ProjectMint from './ProjectMint';
import env from '../env';

const ProjectStatus=({ dataEth, setDataEth, message, setMessage}) => {

    const notStartedPaused = () => {
        let htmlData="";
        let secondaryData="";
        if (!dataEth.contractInfo.loadedContract) {
            htmlData ="Error Loading Contract: "+env.mintContract;
        } else if (dataEth.contractInfo.totalSupply===parseInt(dataEth.contractInfo.MAX_SUPPLY)) {
            htmlData ="SpareSouls Revealed";
        } else if (parseInt(dataEth.contractInfo.totalSupply)<parseInt(dataEth.contractInfo.MAX_SUPPLY)) {
            htmlData =" Stay tuned to mint your SpareSouls";
        } else {
            // Sold Out
            htmlData="Sold Out";
            secondaryData=<a href={env.secondaryMarket} target='_blank' rel='noreferrer noopener'> 
                <Text marginTop='10px' fontSize='18px'>Never know when you will need an extra spare soul, just in case buy it now. </Text>
            </a>;
        }

        return (
            <Flex align="center" justify="center">
                <Box width="80%">
                    <Text marginTop="10px" fontSize="24px" textShadow="0 2px #090909">{htmlData}</Text>
                    {secondaryData}
                </Box>
            </Flex>
        )
    }

    const notConnected = () => {
        return (
                <>
                    <Text
                        fontSize="24px"
                        textShadow="0 2px 2px #010101"
                        marginBottom="2"
                    >
                        CONNECT TO MINT YOUR EXTRA SPARE SOUL
                    </Text>
                </>
        )
    }

    const availableMint = () => {
        return (
            <>
                <ProjectMint dataEth={dataEth} setDataEth={setDataEth} message={message} setMessage={setMessage} />
            </>
        )
    }

    const notNetwork = () => {
        return (
            <>
            <Text
                fontSize="24px"
                textShadow="0 2px 2px #010101"
                marginBottom="2"
            >
                    Check Network in Wallet
            </Text>
            </>);
    }

    const renderStatus = () => {
        let htmlData="";
        if (!dataEth?.isConnected) {
            htmlData=notConnected();
        } else if (dataEth?.networkConnected!==undefined && dataEth?.networkConnected!==env.networks[env.networkRequired].chainId) {
            htmlData=notNetwork();
        } else if (dataEth?.contractInfo?.mintState===0) {
            htmlData=notStartedPaused();
        } else if (dataEth?.contractInfo?.mintState!==0) {
            if (dataEth?.contractInfo?.totalSupply===dataEth.contractInfo.MAX_SUPPLY) {
                htmlData=notStartedPaused()
            } else {
                htmlData=availableMint()
            }
        }
        
        return(
            <Flex justify="center" align="center" height="100%" paddingBottom="20px" paddingTop="0px">
                <Box width="650px">
                    {htmlData}
                </Box>
            </Flex>
        );

    }


    return(
        <>
            {renderStatus()}
        </>
    )
}

export default ProjectStatus;